module.exports = __webpack_public_path__ + "img/exampleFaceNew.576d89b0.png";